import { testimonials } from '@/mocks/home';

export default function Testimonials() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary-50 mb-4">
            <i className="ri-chat-heart-line text-secondary-500 text-sm"></i>
            <span className="text-secondary-600 text-xs font-medium">玩家评价</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 font-heading mb-3">
            <span className="text-primary-600">5000万+</span>玩家的共同选择
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            听听真实玩家的评价，了解他们为什么选择开云棋牌
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {testimonials.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl border border-background-200 p-5 md:p-6 hover:border-secondary-200 transition-all duration-300"
            >
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={item.avatar}
                  alt={item.name}
                  className="w-11 h-11 rounded-full object-cover"
                />
                <div>
                  <div className="font-semibold text-foreground-900 text-sm">
                    {item.name}
                  </div>
                  <div className="text-foreground-400 text-xs">{item.role}</div>
                </div>
              </div>
              <div className="flex items-center gap-0.5 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-xs ${
                      i < item.rating
                        ? 'ri-star-fill text-accent-500'
                        : 'ri-star-line text-foreground-300'
                    }`}
                  ></i>
                ))}
              </div>
              <p className="text-foreground-600 text-sm leading-relaxed mb-3">
                "{item.content}"
              </p>
              <div className="pt-3 border-t border-background-200">
                <span className="text-xs text-foreground-400 flex items-center gap-1.5">
                  <i className="ri-gamepad-line"></i>
                  {item.game}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}